// src/pages/Tests/TestPlay.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../../api"; 
// path check kar lena (Tests folder ke hisaab se)
import ProctoredTest from "./ProctoredTests.jsx";



export default function TestPlay() {
  const { type, id } = useParams();

  const [test, setTest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [answers, setAnswers] = useState({});
  const [marked, setMarked] = useState({});
  
  const [currentIndex, setCurrentIndex] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  // TIMER STATE
  const [timeLeft, setTimeLeft] = useState(null);

  // -------------------------------------------------------------
  // FETCH TEST
  // -------------------------------------------------------------
 useEffect(() => {
  const fetchTest = async () => {
    try {
      // 1️⃣ Pehle test fetch karo
      const res = await API.get(
        `/test-types/${type.toLowerCase()}/${id}`
      );

      const mapped = res.data.questions.map(q => {

 let correctIndex = null;

 if (typeof q.answer === "object" && q.answer !== null) {
   correctIndex = q.answer.index;
 }
 else if (typeof q.answer === "number") {
   correctIndex = q.answer;
 }
 else if (typeof q.answer === "string") {

  const val = q.answer.trim().toUpperCase();

  // LETTER BASED (A,B,C,D,E)
  if (/^[A-Z]$/.test(val)) {
    correctIndex = val.charCodeAt(0) - 65;
  }

  // fallback: match by text
  else {
    const found = q.options?.findIndex(
      o => o.text?.toLowerCase() === val.toLowerCase()
    );

    if (found !== -1) correctIndex = found;
  }
}

 return {
   ...q,
   correctIndex
 };
});

setTest({
 ...res.data,
 questions: mapped
});

      // Timer set
      if (res.data.timer && res.data.duration) {
        setTimeLeft(res.data.duration);
      }

      // 2️⃣ Ab event track karo (res ab defined hai ✅)
      await API.post("/events/track", {
        eventName: "test_started",
        eventType: "test",
        entityId: id,
        metadata: {
          testType: type,
          totalQuestions: res.data.questions.length,
        },
      });

    } catch (err) {
      setError("❌ Failed to load test");
    } finally {
      setLoading(false);
    }
  };

  fetchTest();
}, [type, id]);

  // -------------------------------------------------------------
  // TIMER
  // -------------------------------------------------------------
  useEffect(() => {
    if (!timeLeft || submitted) return;

    if (timeLeft === 0) {
  handleSubmit();   // <-- result page par le jayega
  return;
}

    const t = setTimeout(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(t);
  }, [timeLeft, submitted]);

  const formatTimer = () => {
    if (timeLeft === null) return "";
    const m = Math.floor(timeLeft / 60);
    const s = (timeLeft % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  // -------------------------------------------------------------
  // ACTIONS
  // -------------------------------------------------------------

  const handleAnswer = (qid, ans) =>
    setAnswers((prev) => ({ ...prev, [qid]: ans }));

  const handleMark = (qid) =>
    setMarked((prev) => ({
      ...prev,
      [qid]: prev[qid] === "review" ? null : "review",
    }));

  const clearResponse = (qid) => {
    setAnswers((prev) => {
      const x = { ...prev };
      delete x[qid];
      return x;
    });
    setMarked((prev) => ({ ...prev, [qid]: null }));
  };

  const handleSubmit = async () => {
  setSubmitted(true);

  // 🔥 FRONTEND SCORE CALCULATION
  let correct = 0;
  let wrong = 0;
  let skipped = 0;

  test.questions.forEach((q) => {
  const userAns = answers[q._id];

  if (userAns === undefined) {
    skipped++;
    return;
  }

  if (q.type === "text") {
    if (
      userAns?.toLowerCase().trim() ===
      q.answer?.toLowerCase().trim()
    ) {
      correct++;
    } else {
      wrong++;
    }
  } 
  else {
    if (userAns === q.correctIndex) {
      correct++;
    } else {
      wrong++;
    }
  }
});

  const total = test.questions.length;
  const score = correct;

  // 🔥 SAVE RESULT TO BACKEND (MOST IMPORTANT)
  await API.post("/tests/save", {
    testId: id,
    testName: test.title || "Untitled Test",
    score,
    total,
    correct,
    wrong,
    unattempted: skipped
  });

  // optional analytics
  await API.post("/events/track", {
    eventName: "test_submitted",
    eventType: "test",
    entityId: id,
    metadata: {
      score,
      correct,
      wrong,
      skipped,
      total
    }
  });

  navigate(`/result/${id}`, {
    state: {
      test,
      answers,
      marked,
      score,
      correctAnswers: correct,
      wrongAnswers: wrong,
      skipped,
      total
    }
  });
};



  const goNext = () =>
    currentIndex < test.questions.length - 1 &&
    setCurrentIndex(currentIndex + 1);

  const goPrev = () =>
    currentIndex > 0 && setCurrentIndex(currentIndex - 1);

  // -------------------------------------------------------------
  // STATUS COLORS
  // -------------------------------------------------------------
  const getStatus = (qId) => {
    if (answers[qId] !== undefined) return "answered";
    if (marked[qId] === "review") return "review";
    return "notVisited";
  };

  // -------------------------------------------------------------
  // RENDER
  // -------------------------------------------------------------
  if (loading) return <p className="text-center mt-10">Loading test...</p>;
  if (error)
    return <p className="text-center text-red-500 mt-10">{error}</p>;
  if (!test) return <p className="text-center mt-10">Test not found.</p>;

  const total = test.questions.length;
  const q = test.questions[currentIndex];
  const qId = q._id;

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* 🔐 PROCTOR ONLY FOR PROCTORED TESTS */}
        <ProctoredTest onAutoSubmit={handleSubmit} />



      {/* ----------------------- SIDEBAR ----------------------- */}
      <aside className="w-72 bg-white border-r p-5 shadow-md">

        {/* TIMER */}
        {test.timer && timeLeft !== null && (
          <div
            className={`
              text-center text-xl font-bold mb-6 py-2 rounded-lg
              ${timeLeft <= 30 ? "bg-red-100 text-red-600 animate-pulse" : "bg-blue-100 text-blue-700"}
            `}
          >
            ⏱ {formatTimer()}
          </div>
        )}

        <h2 className="text-lg font-bold text-gray-800 mb-4">
          Question Navigator
        </h2>

        <div className="grid grid-cols-5 gap-2">
          {test.questions.map((ques, i) => {
            const st = getStatus(ques._id);

            return (
              <button
                key={ques._id}
                onClick={() => setCurrentIndex(i)}
                className={`w-10 h-10 rounded-full text-sm font-semibold
                  ${currentIndex === i
                    ? "bg-blue-600 text-white"
                    : st === "answered"
                    ? "bg-green-500 text-white"
                    : st === "review"
                    ? "bg-yellow-400 text-white"
                    : "bg-gray-300 text-gray-700"}
                `}
              >
                {i + 1}
              </button>
            );
          })}
        </div>

        <div className="mt-6 text-sm">
          <p>🟦 Current</p>
          <p className="text-green-600">🟩 Attempted</p>
          <p className="text-yellow-500">🟨 Marked</p>
          <p className="text-gray-500">⬜ Not Visited</p>
        </div>
      </aside>

      {/* ----------------------- MAIN AREA ----------------------- */}
      <main className="flex-1 p-8">
        <h1 className="text-2xl font-bold mb-3">{test.title}</h1>
        <p className="text-gray-600 mb-6">Question {currentIndex + 1} / {total}</p>

        {/* QUESTION CARD */}
        <div className="bg-white p-6 shadow rounded-xl border">
          <h2 className="text-lg font-semibold mb-4">
  {typeof q.question === "object" ? q.question.text : q.question}
</h2>
          <div className="mb-3">
  <span
    className={`px-3 py-1 text-sm rounded-full font-semibold
      ${
        q.type === "mcq"
          ? "bg-blue-100 text-blue-700"
          : q.type === "truefalse"
          ? "bg-purple-100 text-purple-700"
          : "bg-gray-200 text-gray-700"
      }
    `}
  >
    {q.type === "mcq"
      ? "Multiple Choice"
      : q.type === "truefalse"
      ? "True / False"
      : "Text Question"}
  </span>
</div>
          {q.media?.url && (
  <img
    src={`${process.env.REACT_APP_API_BASE_URL}${q.media.url}`}
    alt=""
    className="mb-4 max-w-md rounded border"
  />
)}


          {/* OPTIONS */}
          {/* MCQ */}
{q.type === "mcq" && 
  q.options?.map((op, i) => {

    const optionText =
      typeof op === "object"
        ? op.text
        : op;

    return (
      <label
        key={i}
        className={`block border px-4 py-3 rounded mb-3 cursor-pointer 
          ${answers[qId] === i ? "bg-blue-100 border-blue-500" : "border-gray-300"}
        `}
      >
        <input
          type="radio"
          name={qId}
          checked={answers[qId] === i}
          onChange={() => handleAnswer(qId, i)}
          disabled={submitted}
          className="mr-2"
        />

        <div>{optionText}</div>
      </label>
    );
  })
}

{/* TRUE / FALSE */}
{q.type === "truefalse" && (
  <div className="flex gap-4">
    <button
      onClick={() => handleAnswer(qId, 0)}
      disabled={submitted}
      className={`px-6 py-3 rounded-lg border font-semibold
        ${answers[qId] === 0
          ? "bg-green-100 border-green-500 text-green-700"
          : "bg-white border-gray-300"}
      `}
    >
      True
    </button>

    <button
      onClick={() => handleAnswer(qId, 1)}
      disabled={submitted}
      className={`px-6 py-3 rounded-lg border font-semibold
        ${answers[qId] === 1
          ? "bg-red-100 border-red-500 text-red-700"
          : "bg-white border-gray-300"}
      `}
    >
      False
    </button>
  </div>
)}

{/* TEXT */}
{q.type === "text" && (
  <input
    type="text"
    className="border rounded px-4 py-2 w-full"
    placeholder="Your answer..."
    value={answers[qId] || ""}
    onChange={(e) => handleAnswer(qId, e.target.value)}
    disabled={submitted}
  />
)}

          {/* MARK / CLEAR */}
          <div className="flex gap-3 mt-4">
            <button
              onClick={() => handleMark(qId)}
              className="px-4 py-2 rounded bg-yellow-200 hover:bg-yellow-300"
            >
              {marked[qId] === "review" ? "✓ Marked" : "Mark for Review"}
            </button>

            <button
              onClick={() => clearResponse(qId)}
              className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
            >
              Clear
            </button>
          </div>
        </div>

        {/* NAV BUTTONS */}
        <div className="flex justify-between mt-8">
          <button
            onClick={goPrev}
            disabled={currentIndex === 0}
            className={`px-4 py-2 rounded 
              ${currentIndex === 0 ? "bg-gray-300 text-gray-500" : "bg-gray-600 text-white hover:bg-gray-700"}
            `}
          >
            ← Previous
          </button>

          {currentIndex === total - 1 ? (
            <button
              onClick={handleSubmit}
              className="px-6 py-2 bg-green-600 text-white rounded hover:bg-green-700"
            >
              Submit Test
            </button>
          ) : (
            <button
              onClick={goNext}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Next →
            </button>
          )}
        </div>

        {/* AFTER SUBMIT */}
        {submitted && (
          <p className="mt-6 text-green-600 font-semibold text-lg">
            🎉 Test Submitted!
          </p>
        )}
      </main>
    </div>
  );
}
